<div class="row">
  <div class="col-sm-6">
    <!-- credit line -->
    <div class="card">
      <img class="status-icon" src="assets/customers/creditLinesStatusImg.svg" alt="An Icon" />
      <div class="card-body">
        <h5 class="card-title">Límite de crédito</h5>
        <p class="card-text">
          Total :
          {{
          this.customerCreditStatus?.informacionLineaCredito
          ?.montoLimiteCredito | currency : "L" : true
          }}
        </p>
        <p class="card-text">
          Disponible :
          {{
          this.getNumericValue(this.customerCreditStatus?.informacionLineaCredito
          ?.montoDisponibleLimiteCredito) | currency : "L" : true
          }}
        </p>
        <p class="card-text">Utilizado</p>
        <div class="progress">
          <div class="progress-bar" role="progressbar" [style.width.%]="this.percentageConsumedOnCreditLine"
            aria-valuemin="0" aria-valuemax="100">
            {{ this.percentageConsumedOnCreditLine }}%
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-sm-6">
    <!-- credit cash line -->
    <div class="card">
      <img class="status-icon" src="assets/customers/creditCashLineStatusImg.svg" alt="An Icon" />
      <div class="card-body">
        <h5 class="card-title">Límite de crédito efectivo</h5>
        <p class="card-text">
          Total :
          {{
          this.customerCreditStatus?.informacionLineaEfectivo
          ?.montoLimiteEfectivo | currency : "L" : true
          }}
        </p>
        <p class="card-text">
          Disponible :
          {{
          this.getNumericValue(this.customerCreditStatus?.informacionLineaEfectivo
          ?.montoDisponibleLimiteEfectivo) | currency : "L" : true
          }}
        </p>
        <p class="card-text">Utilizado</p>
        <div class="progress">
          <div class="progress-bar" role="progressbar" [style.width.%]="this.percertageConsumenOnCreditCashLine"
            aria-valuemin="0" aria-valuemax="100">
            {{ this.percertageConsumenOnCreditCashLine }}%
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-sm-6">
    <!-- term card -->
    <div class="card">
      <img class="status-icon" src="assets/customers/creditStatusTerm.svg" alt="An Icon" />
      <div class="card-body">
        <h5 class="card-title">Condiciones de crédito PLAZO</h5>
        <p class="card-text">
          Minimo
          <strong>{{ this.customerCreditPolicy?.term?.min || 0}} {{this.customerCreditPolicy ? 'meses' : ''}}</strong>
        </p>
        <p class="card-text">
          Maximo
          <strong>{{ this.customerCreditPolicy?.term?.max || 0}} {{this.customerCreditPolicy ? 'meses' : ''}}</strong>
        </p>
      </div>
    </div>
  </div>
  <div class="col-sm-6">
    <!-- downpayment card -->
    <div class="card">
      <img class="status-icon" src="assets/customers/creditStatusDownpayment.svg" alt="An Icon" />
      <div class="card-body">
        <h5 class="card-title">
          <i class="fa fa-money-bill"></i>
          Condiciones de crédito PRIMA
        </h5>
        <p class="card-text">
          Minimo
          <strong>{{ this.customerCreditPolicy?.downPayment?.min || 0 }} {{this.customerCreditPolicy ? '%' :
            ''}}</strong>
        </p>
        <p class="card-text">
          Maximo
          <strong>{{ this.customerCreditPolicy?.downPayment?.max || 0}} {{this.customerCreditPolicy ? '%' :
            ''}}</strong>
        </p>
      </div>
    </div>
  </div>
</div>